var _defs, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram_2_",
    "data-name": "instagram (2)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.051,
    height: 16.051,
    viewBox: "0 0 16.051 16.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.008,
    x2: 0.5,
    y2: 0.998,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e09b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c74c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: -0.451,
    y2: 1.462,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: -1.396,
    y2: 6.586,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    d: "M11.269,0H4.782A4.787,4.787,0,0,0,0,4.782v6.488a4.787,4.787,0,0,0,4.782,4.782h6.488a4.787,4.787,0,0,0,4.782-4.782V4.782A4.787,4.787,0,0,0,11.269,0Zm3.167,11.269a3.167,3.167,0,0,1-3.167,3.167H4.782a3.167,3.167,0,0,1-3.167-3.167V4.782A3.167,3.167,0,0,1,4.782,1.615h6.488a3.167,3.167,0,0,1,3.167,3.167v6.488Z",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    "data-name": "Path 3224",
    d: "M137.151,133a4.151,4.151,0,1,0,4.151,4.151A4.156,4.156,0,0,0,137.151,133Zm0,6.688a2.537,2.537,0,1,1,2.537-2.537A2.537,2.537,0,0,1,137.151,139.688Z",
    transform: "translate(-129.126 -129.126)",
    fill: "url(#linear-gradient-2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 0.995,
    cy: 0.995,
    r: 0.995,
    transform: "translate(11.19 2.911)",
    fill: "url(#linear-gradient-3)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.69ba4363e910586fda90b868789b7f8c.svg";
export { ForwardRef as ReactComponent };